module.exports = __webpack_public_path__ + "static/media/panskura_college.092ad54c.jpeg";